module.exports = __webpack_public_path__ + "img/jeland_logo.d130cf00.png";